<template>
  <div class="center-middle">
    <h1>404</h1>
    <h4>PAGE NOT FOUND</h4>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
